export default __webpack_public_path__ + "static/raven-2-53812e439e84e787d90324251de2f7d1.webp";